
import { useCallback, useState } from "react";

interface PaginationOptions {
    initialPageSize?: number;
}

export function useServerPagination({
    initialPageSize = 20,
}: PaginationOptions = {}) {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(initialPageSize);
    const [total, setTotal] = useState(0);

    const resetPage = useCallback(() => {
        setPage(1);
    }, []);

    const changePageSize = useCallback((size: number) => {
        setPageSize(size);
        setPage(1);
    }, []);

    return {
        page,
        pageSize,
        total,
        setPage,
        setTotal,
        resetPage,
        changePageSize,
    };
}
